import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURL = 'adquisiciones/regimen-fiscal';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

export const getRegimenesFiscales = async () => {
  try {
    const response = await API.get(baseURL);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getRegimenFiscal = async (id) => {
  try {
    const response = await API.get(`${baseURL}/${id}`);
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

export const postRegimenFiscal = async (values) => {
  try {
    const response = await API.post(baseURL, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const patchRegimenFiscal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, values);
    onSuccess(response, 'Editado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const deleteRegimenFiscal = async (id) => {
  try {
    const response = await API.delete(`${baseURL}/${id}`);
    onSuccess(response, 'Eliminado correctamente.');
    return true;
  } catch (error) {
    onError(error);
    return false;
  }
};
